import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-green-400 px-3 py-2" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_enter_data = _resolveComponent("enter-data")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_with_services_filters = _resolveComponent("with-services-filters")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modals_state.is_on_enter_data)
      ? (_openBlock(), _createBlock(_component_enter_data, {
          key: 0,
          "is-loading": _ctx.modals_state.is_loading,
          "additional-services": _ctx.getAdditionalServices,
          "invoice-number": _ctx.modals_state.invoice_number,
          onCancel: _ctx.closeEnterData,
          onSubmitted: _ctx.completeData,
          onDeleted: _ctx.afterServiceDeleted
        }, null, 8, ["is-loading", "additional-services", "invoice-number", "onCancel", "onSubmitted", "onDeleted"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Накладные & Заказы с доп. услугами" }),
      (_ctx.isCanDeleteAdditional)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/invoices/delete-additional"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, {
                class: "small red",
                hint: "Удаление доп. услуг импортом"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка накладных & заказов с доп. услугами произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadDataWithServices(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_with_services_filters, {
              onApply: _ctx.applyFilters,
              onReset: _ctx.resetFilters,
              loading: _ctx.state.is_loading
            }, null, 8, ["onApply", "onReset", "loading"]),
            _createVNode(_component_table_scroll_wrapper, {
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.DataWithServicesColumns,
                  rows: _ctx.state.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.filters_state.limit,
                  "pagination-total-items": _ctx.state.pagination.total_items,
                  "pagination-current-page": _ctx.state.pagination.current_page,
                  "pagination-total-pages": _ctx.state.pagination.total_pages,
                  onChangePage: _ctx.loadDataWithServices,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  buttons: _withCtx(() => [
                    (_ctx.isCanDownloadExcel)
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "primary text small mr-2",
                          onClick: _ctx.exportExcel,
                          loading: _ctx.state.is_loading,
                          hint: "Скачать эксель"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"]))
                      : _createCommentVNode("", true)
                  ]),
                  td: _withCtx(({ row, column }) => [
                    (column.key === 'info')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (row.entity_type === 0)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: `/invoice/${row.meta.invoice_id}`,
                                target: "_blank",
                                class: "text-blue-500 font-semibold hover:underline"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row[column.key]), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (row.entity_type === 1)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: `/order/${row.meta.order_id}`,
                                target: "_blank",
                                class: "text-blue-500 font-semibold hover:underline"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row[column.key]), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (column.key === 'company_name')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key])), 1)
                          ], 64))
                        : (column.key === 'from')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(row.from) + " - " + _toDisplayString(row.to), 1)
                            ], 64))
                          : (column.key === 'created_at')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.created_at)), 1)
                              ], 64))
                            : (column.key === 'additional_service')
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(row[column.key], (service, i) => {
                                  return (_openBlock(), _createBlock(_component_cheap, {
                                    key: `AdditionalService-${row.info}-${i}`,
                                    class: _normalizeClass([
                                        'mb-2 small',
                                        {
                                            primary: service.statusId === 17,
                                            green: service.statusId === 18,
                                        },
                                    ])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(service.type_name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                }), 128))
                              : (column.key === 'cubature')
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(row.additional_service, (service, i) => {
                                    return (_openBlock(), _createBlock(_component_cheap, {
                                      key: `AdditionalServiceAsd-${row.info}-${i}`,
                                      class: "mb-2 small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(service.valueForWarehouseServices || '-'), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                : (column.key === 'status_name' && row.status_name)
                                  ? (_openBlock(), _createBlock(_component_cheap, {
                                      key: 6,
                                      class: _normalizeClass([
                                        `small ${_ctx.WITH_SERVICES_STATUSES_COLORS[row.status_id]}`,
                                    ])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.status_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                      _createTextVNode(_toDisplayString(row[column.key]), 1)
                                    ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.isCanComplete(row))
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 0,
                            hint: "Внести данные",
                            class: "primary extra-small",
                            onClick: ($event: any) => (_ctx.openEnterData(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (row.additional_service_status === 'completed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
    ])
  ]))
}